<template>
  <div class="pt-100 pb-100">
    <div class="container">
      <div class="d-sm-flex align-items-center justify-content-between mb-50 position-relative z-1">
        <div
          class="section-title left-title mb-0"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <span class="top-title">CAPABILITIES</span>
          <h4 title="We connect brands with celebrities and influencers for powerful digital campaigns.">
            MyCelebrity offers a range of services to help brands leverage celebrity and influencer for marketing and promotions.
          </h4>
        </div>
        <router-link
          to="/services"
          class="default-btn btn-two mt-3 mt-sm-0"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          VIEW ALL SERVICES
          <img
            src="../../assets/images/icon-right-white.png"
            alt="right-chevron"
          />
        </router-link>
      </div>

      <div
        class="row justify-content-center g-4"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="300"
      >
        <div
          class="col-lg-4 col-md-6"
          v-for="capabilitie in capabilities"
          :key="capabilitie.id"
        >
          <div class="capabilities-single-item transition-y d-flex flex-column h-100">
            <div class="icon">
              <img :src="capabilitie.imageIcon" alt="icon" />
            </div>
            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">{{ capabilitie.title }}</h3>
            <p>{{ capabilitie.description }}</p>
            <router-link :to="capabilitie.link" class="read-more mt-auto">
              READ MORE
              <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
                src="../../assets/images/icon-right-red.png"
                alt="icon-right-red"
              />
            </router-link>
          </div>
        </div>
      </div>

      <div class="border-style pt-75"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CapabilitiesContent",
  data() {
    return {
      capabilities: [
        {
          id: 1,
          imageIcon: require("../../assets/images/guest-star.png"),
          title: "Influencer Marketing & Celebrity Promotions",
          description:
            "Connect your brand with the right faces — from regional stars to Bollywood icons and social media influencers across India. From storytelling to strategy, we ensure visibility, relatability, and results.",
        link: "/service-details-1"
          },
        {
          id: 2,
          imageIcon: require("../../assets/images/camera.png"),
          title: "Ad Shoots & TV Commercials (TVCs)",
          description:
            "We produce compelling visuals from concept to camera. Our team handles everything: scripting, casting, shooting, post-production, and publishing across media.",
        link: "/service-details-2"
          },
        {
          id: 3,
          imageIcon: require("../../assets/images/content.png"),
          title: "Digital Marketing Services",
          description:
            "SEO, Google Ads, Meta campaigns, content strategy, and more — we help brands scale online with data-backed growth tactics.",
            link: "/service-details-3"
        },
        {
          id: 4,
          imageIcon: require("../../assets/images/inaugurations.png"),
          title: "Events & Inauguration",
          description:
            "Need to launch a product, open a store, or elevate your next big event? We manage everything end-to-end from celebrity guests to press coverage.",
        link: "/service-details-4"
          },
        {
          id: 5,
          imageIcon: require("../../assets/images/bluebadge.png"),
          title: "Verified Badge Services (Instagram & Facebook)",
          description:
            "We help eligible public figures, influencers, and brands secure the verified blue tick, increasing credibility and brand trust.",
        link: "/service-details-5"
          },
        {
          id: 6,
          imageIcon: require("../../assets/images/conference.png"),
          title: "PR Article & Media Coverage Services",
          description:
            "We help brands build credibility, visibility, and trust through powerful PR article placements in top-tier media outlets.",
        link: "/service-details-6"
          },
      ],
    };
  },
});
</script>

<style lang="scss" scoped>
.capabilities-single-item {
  background-color: var(--whiteColor);
  border-radius: 20px;
  padding: 48px 38px;
  margin-bottom: 0; // Handled by g-4 in row
  transition: var(--transition);
  display: flex;
  flex-direction: column;
  height: 100%;

  .icon {
    width: 70px;
    height: 70px;
    line-height: 70px;
    background-color: #f2f2f8;
    text-align: center;
    border-radius: 50px;
    margin-bottom: 15px;
  }

  h3 {
    font-size: 22px;
    margin-bottom: 15px;
  }

  p {
    margin-bottom: 35px;
  }

  .read-more {
    margin-top: auto;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
}

/* Responsive styles */
@media only screen and (max-width: 767px) {
  .capabilities-single-item {
    padding: 20px;
    h3 {
      font-size: 20px;
    }
    p {
      margin-bottom: 15px;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .capabilities-single-item {
    padding: 30px;
  }
}
</style>
